import createWaypointRenderer from './helpers/createWaypointRenderer';
import normalizeRenderingError from './helpers/normalizeRenderingError';
import renderMarkdownString from './helpers/renderMarkdownString';

type TVariables = Record<string, unknown>;

const nonStrictNonEscapedRenderer = createWaypointRenderer({ strict: false, outputEscape: false });
const strictNonEscapedRenderer = createWaypointRenderer({ strict: true, outputEscape: false });

type TEvalLiquidProps = {
  template: string;
  variables: TVariables;
};
export function evalLiquid({ template, variables }: TEvalLiquidProps): unknown {
  try {
    return nonStrictNonEscapedRenderer.evalValueSync(template, variables);
  } catch (e) {
    throw normalizeRenderingError(e, { template, variables });
  }
}

type TRenderLiquidProps = {
  template: string;
  variables: TVariables;
  skipLiquid: boolean;
  strictVariablesRendering: boolean;
};
export function renderLiquid({
  template,
  variables,
  skipLiquid,
  strictVariablesRendering,
}: TRenderLiquidProps): string {
  if (skipLiquid) {
    return template;
  }
  try {
    const engine = strictVariablesRendering ? strictNonEscapedRenderer : nonStrictNonEscapedRenderer;
    return engine.renderSync(engine.parse(template), variables);
  } catch (e) {
    throw normalizeRenderingError(e, { template, variables });
  }
}

const strictEscapedRenderer = createWaypointRenderer({ strict: true, outputEscape: true });
const nonStrictEscapedRenderer = createWaypointRenderer({ strict: false, outputEscape: true });

type TRenderOutputEscapedLiquidProps = {
  template: string;
  variables: TVariables;
  strictVariablesRendering: boolean;
};
export function renderOutputEscapedLiquid({
  template,
  variables,
  strictVariablesRendering,
}: TRenderOutputEscapedLiquidProps): string {
  try {
    const engine = strictVariablesRendering ? strictEscapedRenderer : nonStrictEscapedRenderer;
    return engine.renderSync(engine.parse(template), variables);
  } catch (e) {
    throw normalizeRenderingError(e, { template, variables });
  }
}

type TRenderMarkdownLiquidProps = {
  template: string;
  variables: TVariables;
  strictVariablesRendering: boolean;
};
export function renderOutputEscapedLiquidMarkdown({
  template,
  variables,
  strictVariablesRendering,
}: TRenderMarkdownLiquidProps): string {
  try {
    const liquid = renderOutputEscapedLiquid({
      template,
      variables,
      strictVariablesRendering,
    });
    return renderMarkdownString(liquid);
  } catch (e) {
    throw normalizeRenderingError(e, { template, variables });
  }
}
